export default "__VITE_ASSET__DNvClrP1__"